import { h } from 'preact'
import { useState, useLayoutEffect } from 'preact/hooks'

export const Vod = (props) => {
   const [vodState, setVod] = useState(props)
   const { cacheKey, background, items, title, vod4 } = vodState

   useLayoutEffect(() => {
      const updateStateWithVod4 = (event) => {
         setVod({ ...vodState, vod4: event.detail.data })
      }
      
      // S'execute au mount
      document.addEventListener('updatevod', updateStateWithVod4)

      // S'execute au Unmount
      return () => {
         document.removeEventListener('updatevod', updateStateWithVod4)
      }
   }, [vodState])

   return (
      <div
         id="bande-vod"
         data-testid="bande-vod"
         class={`bande-vod mb-4 ${background === 'grey' ? 'py-3 bg-gray2 item-vod-bg-white' : 'item-vod-bg-gray2'}`}
         data-cache-key={cacheKey}
      >
         <div class="container-fluid">
            <div class="row">
               <div class="col-12">
                  <h2 class="mb-1 mb-md-2">{title}</h2>
               </div>
               <div class="col-12">
                  <div class="row vod-slider">
                     {items.map((item, index) => (
                        <RecoVideo {...item} index={index + 1} />
                     ))}
                     {vod4 !== undefined ? <RecoVideo {...vod4.items[0]} index="4" /> : null}
                  </div>
               </div>
            </div>
         </div>
      </div>
   )
}

const RecoVideo = ({ image, alt, description, CTA, index }) => {
   let cappingAdv
   if (CTA.analytics.pdbSc === 'adv') {
      cappingAdv = {
         'data-pdb-ta': CTA.analytics.advTracker,
         'data-adv-canal': CTA.analytics.advCanal,
         'data-adv-cappingdata': CTA.analytics.advCappingdata,
      }
   }

   return (
      <div class="col-3">
         <div
            class="card ob1-push lien-composite-before"
            data-testid={`vod${index}`}
            data-pdb-zid={CTA.analytics.pdbZid}
            data-pdb-sc={CTA.analytics.pdbSc}
            data-pdb-idc={CTA.analytics.pdbIdc}
            data-pdb-vi={CTA.analytics.pdbVi}
            {...cappingAdv}
            data-oevent-category={CTA.analytics.oeventCategory}
            data-oevent-action={CTA.analytics.oeventAction}
            data-oevent-label={CTA.analytics.oeventLabel}
            data-oevent-other={CTA.analytics.oeventOther}
         >
            <div class="card-header">
               <img src={image} alt={alt} loading="lazy" class="card-img-top" />
               <div class="card-text">
                  <h3 class="teaser">{description}</h3>
                  <a class="cta o-link-arrow" href={CTA.URL} target={CTA.target !== '' ? '_blank' : ''}>
                     {CTA.label} <span class="sr-only">{alt}</span>
                  </a>
               </div>
            </div>
         </div>
      </div>
   )
}
